/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-unresolved */
import PropTypes from 'prop-types'
import USBAutocomplete from '@usb-inner-src/react-autocomplete'
import { BlockLayout } from '@usb-ui-tools/react-billpay-layout'
import { useEffect } from 'react'
import ErrorElement from '../error/error'
import { useMultilingualService } from '../../../../../service/multilingualService'
import './search-bill.scss'
import styles from './search-bills.module.scss'
/**
 * Returns search result of company
 * @method
 * @param {Object} intl - locale of DashboardNearbyMarchants
 * @param {String} paymybillImg - avatar image path
 * @param {Function} setSearchVal - set the search value
 * @param {Object} searchBillData - search bill data
 * @param {Function} setTypeaheadVal - set selected search value
 * @returns {HTMLElement} Returns segment with list of marchants
 */
const SearchBills = ({
  setSearchVal,
  searchBillData,
  setTypeaheadVal,
  loading,
  autocompleteRef
}) => {
  const { SEARCHBILLS } = useMultilingualService('addBillDashboard')
  // const { HEADER } = useMultilingualService('addBillDashboard')
  useEffect(() => {
    // const input = autocompleteRef?.current?.querySelector('input')
    const input = document.querySelector(
      '#add-bill-dashboard-search-input1 > input'
    )
    const eventTrigger = (event) => {
      if (event.charCode === 32 || event.keyCode === 32 || event.code === '') {
        const value = event.target.value.replace(/\s/gi, '')
        if (value === '') {
          event.preventDefault()
          event.stopPropagation()
        }
      }
    }

    input?.addEventListener('keypress', eventTrigger, true)
    return () => {
      input?.removeEventListener('keypress', eventTrigger, true)
    }
  }, [document.querySelector('#add-bill-dashboard-search-input1 > input')])

  return (
    <BlockLayout
      actAs="CardChild"
      compact
      // contentOnTop={
      //   <p className="usb-tg-body-medium usb-c-gray-80">
      //     {HEADER?.DASHBOARD_SUB_TITLE}
      //   </p>
      // }
    >
      <div className="search">
        <div className="searchbill">
          <p
            id="payee-dashboard-search-bills-subheader"
            className="usb-tg-subheader-large usb-c-usb-blue search-header"
          >
            {SEARCHBILLS?.DASHBOARD_INSTRUCTION}
          </p>
          <div
            style={{ marginTop: '-1rem' }}
            className={styles['auto-complete-wrapper1']}
          >
            {/* <USBAutocomplete
              ref={autocompleteRef}
              id="add-bill-dashboard-search-input"
              addClasses="searchbox"
              autocompletePlaceholder={
                SEARCHBILLS?.DASHBOARD_SEARCH_INSTRUCTION
              }
              isClearable
              handleChange={(e) => {
                setSearchVal(e.target.value)
              }}
              items={searchBillData}
              minChar={3}
              isLoading={loading}
              errorNode={<ErrorElement />}
              handleOnSelect={setTypeaheadVal}
              pageSize={6}
            /> */}
            <USBAutocomplete
              ref={autocompleteRef}
              pageSize={6}
              id="add-bill-dashboard-search-input1"
              addClasses="searchbox"
              autocompletePlaceholder={
                SEARCHBILLS?.DASHBOARD_SEARCH_INSTRUCTION
              }
              dropdownType="outlined"
              filterType="remote"
              data-test="autocomplete-btn"
              // isClearable
              handleChange={(e) => {
                setSearchVal(e.target.value)
              }}
              handleOnSelect={setTypeaheadVal}
              minChar={3}
              items={searchBillData}
              errorNode={<ErrorElement />}
              isLoading={loading}
            />
          </div>
        </div>
      </div>
    </BlockLayout>
  )
}

SearchBills.propTypes = {
  setSearchVal: PropTypes.func.isRequired,
  searchBillData: PropTypes.objectOf(PropTypes.any),
  setTypeaheadVal: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  autocompleteRef: PropTypes.objectOf(PropTypes.any).isRequired
}
SearchBills.defaultProps = {
  searchBillData: {}
}

export default SearchBills
